module.exports = __webpack_public_path__ + "static/media/flexo.83964a0f.png";